import _createForOfIteratorHelper from "D:/git/aexdo_frontend_local/aexdo_frontend/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
var globalSettings = ['baseApiUrl', 'maxParallelImageRequests', 'workerClass', 'workerCount', 'workerUrl'];
export default function setGlobals(mapLib, props) {
  var _iterator = _createForOfIteratorHelper(globalSettings),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;

      if (key in props) {
        mapLib[key] = props[key];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (props.RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === 'unavailable') {
    mapLib.setRTLTextPlugin(props.RTLTextPlugin, function (error) {
      if (error) {
        // eslint-disable-next-line
        console.error(error);
      }
    }, false);
  }
}